import React, { Component } from 'react'
import { NavLink, withRouter } from 'react-router-dom'
import Router from './../services/Router'
import { Bookmark } from './'

class Notification extends Component {
  isActive = () => () => {
    const {location} = this.props
    return location.pathname.split('/').indexOf('bookmarks') !== -1
  }

  render() {
    return (
      <div className="bookmark-nav">
        <NavLink className="btn" to={Router.bookmarks.viewed} isActive={this.isActive()}>
          <Bookmark width="24" height="24"/>
        </NavLink>
      </div>
    )
  }
}

export default withRouter(Notification)


// WEBPACK FOOTER //
// ./src/components/Bookmarks.js